"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  options: function options(h, conf, key) {
    var list = [];
    conf.__slot__.options.forEach(function (item) {
      list.push(h("el-option", {
        "attrs": {
          "label": item.label,
          "value": item.value,
          "disabled": item.disabled
        }
      }));
    });
    return list;
  }
};